import { useMemo } from 'react';

import useForm from '../../utils/useForm';
import LenderService from '../../../services/LenderService';

const useImportForm = (onSubmit, values) => {
  const hasValues = !!values;

  const fields = useMemo(
    () => [
      {
        title: '',
        isTitleHidden: true,
        fields: [
          {
            title: 'Date started',
            name: 'created_at',
            type: 'date',
            readOnly: true,
            isHidden: () => !hasValues,
          },
          {
            title: 'Status',
            name: 'status',
            type: 'text',
            readOnly: true,
            format: (vals) => vals?.status?.toLowerCase?.(),
            isHidden: () => !hasValues,
          },
          {
            title: 'Lender',
            name: 'lender_id',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['lenders'],
              queryFn: LenderService.getLenders,
              labelKey: 'name',
            },
            required: true,
            readOnly: hasValues,
            link: () => `/lenders/${values.lender_id}?tab=Lender`,
          },
          {
            title: 'Loan Number',
            name: '_loan.pixel_loan_number',
            type: 'text',
            readOnly: true,
            isHidden: () => !hasValues,
            link: () =>
              values.loan_id ? `/loans/${values.loan_id}?tab=Loan` : null,
          },
          {
            title: 'Property',
            name: '_loan._property.address_line_1',
            type: 'text',
            readOnly: true,
            isHidden: () => !hasValues,
            link: () => `/loans/${values.loan_id}?tab=Property`,
          },
        ],
      },
    ],
    [hasValues, values?.lender_id, values?.loan_id]
  );

  return useForm({ fields, onSubmit, values });
};

export default useImportForm;
